import { render, staticRenderFns } from "./DigitalForm.vue?vue&type=template&id=74ac1081&scoped=true&"
import script from "./DigitalForm.vue?vue&type=script&lang=js&"
export * from "./DigitalForm.vue?vue&type=script&lang=js&"
import style0 from "./DigitalForm.vue?vue&type=style&index=0&id=74ac1081&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ac1081",
  null
  
)

export default component.exports